module.exports = __webpack_public_path__ + "static/media/arrow-alt-circle-down.c748d9a4.svg";